module.exports = __webpack_public_path__ + "img/usa-diabetes-mellitus-female.b651314f.png";